import RentingList from '@/components/Renting/RentingList'
import RentingForm from '@/components/Renting/RentingForm'
import RentingDetail from '@/components/Renting/RentingDetail'

let RentingRouter = [{
    path: '/renting',
    name: 'RentingList',
    component: RentingList,
    meta: {
      title: 'Commandes',
      requiresAuth: true,
      authorizations: ['renting_index', 'desktop_access']
    }
  },
  {
    path: '/renting/status/:status',
    name: 'RentingListByStatus',
    component: RentingList,
    meta: {
      title: 'Commandes',
      requiresAuth: true,
      authorizations: ['renting_index', 'desktop_access']
    }
  },
  {
    path: '/renting/new',
    name: 'RentingNew',
    component: RentingForm,
    meta: {
      title: 'Nouvelle commande',
      requiresAuth: true,
      authorizations: ['renting_new', 'desktop_access']
    }
  }, {
    path: '/renting/:id/edit',
    name: 'RentingEdit',
    component: RentingForm,
    meta: {
      title: 'Modifier une commande',
      requiresAuth: true,
      authorizations: ['renting_edit', 'desktop_access']
    }
  }, {
    path: '/renting/:id',
    name: 'RentingDetail',
    component: RentingDetail,
    meta: {
      title: 'Fiche commande',
      requiresAuth: true,
      authorizations: ['renting_show', 'desktop_access']
    }
  }
]

export default RentingRouter



// WEBPACK FOOTER //
// ./src/components/Renting/router.js